<p-panel class="panel-no-header">
  <p-tabView
    *ngIf="!isRefreshing && visibleTabs.length > 0"
    [activeIndex]="activeIndex"
    (activeIndexChange)="onTabChange($event)"
  >
    <p-tabPanel *ngFor="let tab of visibleTabs" [header]="tab.displayName" [cache]="true">
      <ng-template pTemplate="content">
        <div [style.height]="getTabHeight(tab)">
          <ng-container *ngTemplateOutlet="contentTemplate; context: { entityAttachment: tab }"></ng-container>
        </div>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</p-panel>
